import * as CookieConsent from "vanilla-cookieconsent";

const onConsent = (cookie) => {
    const analytics = cookie.categories.includes("analytics") ? 1 : 0;
    const marketing = cookie.categories.includes("marketing") ? 1 : 0;

    const xhr = new XMLHttpRequest();
    xhr.open("GET", window.cookieConsentApiUrl + '&analytics=' + analytics + '&marketing=' + marketing, true);
    xhr.send();
    
    window.gtag('consent', 'update', {
        'analytics_storage': analytics ? 'granted' : 'denied',
        'ad_storage': marketing ? 'granted' : 'denied',
        'ad_user_data': marketing ? 'granted' : 'denied',
        'ad_personalization': marketing ? 'granted' : 'denied',
        'personalization_storage': marketing ? 'granted' : 'denied',
    });

    window.dataLayer.push({
        event: 'update_consent'
    });
};

window.CookieConsent = CookieConsent;
window.cookieConsentOptions = {
    autoShow: false,
    onConsent: ({cookie}) => {
        onConsent(cookie);
    },
    onChange: ({cookie, changedCategories, changedServices}) => {
        onConsent(cookie);
    },
    disablePageInteraction: true,
    guiOptions: {
        consentModal: {
            layout: "cloud",
            position: "bottom center",
            equalWeightButtons: false,
            flipButtons: false,
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: false,
            flipButtons: false,
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        analytics: {},
        marketing: {}
    },
    language: {
        default: "en",
        autoDetect: "browser",
        translations: {
            cs: {
                consentModal: {
                    title: "Podělíte se o sušenky? 🍪",
                    description: "Nakrmený web je spokojený web. Cookies nám pomáhají lépe porozumět tomu, jak web používáte, přizpůsobovat obsah vašim potřebám a zobrazovat personalizovanou reklamu. Díky tomu můžeme neustále zlepšovat naše služby.",
                    acceptAllBtn: "Ano, dám vám je",
                    showPreferencesBtn: "Vybrat konkrétní",
                    footer: "<a href=\"https://www.vas-hosting.cz/ochrana-osobnich-udaju\">Ochrana údajů</a>\n<a href=\"https://www.vas-hosting.cz/obchodni-podminky\">Obchodní podmínky</a>\n<a target='_blank' href=\"https://business.safety.google/privacy/\">Jak Google zpracovává osobní údaje</a>"
                },
                preferencesModal: {
                    title: "Dáváme na vědomí, že používáme cookies. 🍪",
                    acceptAllBtn: "Povolit všechny",
                    acceptNecessaryBtn: "Odmítnout všechny",
                    savePreferencesBtn: "Uložit nastavení",
                    closeIconLabel: "Zavřít okno",
                    serviceCounterLabel: "Služba|Služby",
                    sections: [
                        {
                            description: "Díky nim náš web plní svou funkci na maximum, na pozadí se nic nezadrhává a vám tak můžeme naservírovat co nejlepší uživatelský zážitek. U každé kategorie cookies si můžete vybrat, jestli je chcete nebo ne. A svou volbu můžete změnit kdykoliv – vy jste tu šéf!"
                        },
                        {
                            title: "Funkční cookies <span class=\"pm__badge\">Nutné pro fungování webu</span>",
                            description: "Soubory cookies, díky kterým náš web funguje na pozadí. Jsou nezbytně nutné pro plynulý chod bez zádrhelů.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytické cookies",
                            description: "Soubory cookies umožňující sledovat anonymní návštěvnost našeho webu.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketingové cookies",
                            description: "Rádi bychom vám dopřáli relevantní reklamy přizpůsobené pro vás a vaše potřeby.",
                            linkedCategory: "marketing"
                        },
                        {
                            description: "Nic neskrýváme. Pokud chcete vědět víc o tom, jak s cookies zacházíme a co to pro vás znamená, mrkněte na naše <a class=\"cc__link\" href=\"https://www.vas-hosting.cz/ochrana-osobnich-udaju\">cookie policy</a>, kde vše rozepisujeme v plném znění."
                        }
                    ]
                }
            },
            en: {
                consentModal: {
                    title: "Hello traveller, will you share your cookies? 🍪",
                    description: "A fed website is a happy website. Cookies help us better understand how you use the website, tailor content to your needs and display personalized advertising. This allows us to continually improve our services.",
                    acceptAllBtn: "Yes, I will share",
                    showPreferencesBtn: "Choose specific",
                    footer: "<a href=\"https://www.vas-hosting.com/ochrana-osobnich-udaju\">Privacy Policy</a>\n<a href=\"https://www.vas-hosting.com/obchodni-podminky\">Terms and conditions</a>\n<a target='_blank' href=\"https://business.safety.google/privacy/\">Google’s Privacy & Terms site</a>"
                },
                preferencesModal: {
                    title: "Let there be known that we use cookies. 🍪",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            description: "Thanks to them, our website fulfills its function to the maximum, nothing lags in the background and we can serve you the best possible user experience. For each category of cookies, you can choose whether you want them or not. And you can change your choice at any time - you're the boss!"
                        },
                        {
                            title: "Functional cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "Cookies that make our website work in the background. They are absolutely necessary for a smooth and trouble-free operation.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Cookies enabling anonymous tracking of our website traffic.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing Cookies",
                            description: "We'd like to treat you to relevant ads tailored to you and your needs.",
                            linkedCategory: "marketing"
                        },
                        {
                            description: "We are not hiding anything. If you want to know more about how we handle cookies and what it means for you, take a look at our <a class=\"cc__link\" href=\"https://www.vas-hosting.com/ochrana-osobnich-udaju\">cookie policy</a>, where we describe everything in full text."
                        }
                    ]
                }
            }
        }
    }
};
